import { render } from "./AddRouteTarget.vue?vue&type=template&id=1c662dd6"
import script from "./AddRouteTarget.vue?vue&type=script&lang=js"
export * from "./AddRouteTarget.vue?vue&type=script&lang=js"
script.render = render

export default script